import axios from 'axios'

import type { components } from '../constants/schema'

/**
 * 메인화면 홈 정보
 * @returns HomeItemsDto
 */
export const getHome = async () => {
  return (await axios.get<components['schemas']['HomeItemsDto']>('/home')).data
}
